import React from 'react';

const LogsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/logs',
			exact: true,
			component: React.lazy(() => import('./LogsPage')),
		},
	],
};

export default LogsPageConfig;
